import { render, staticRenderFns } from "./Invendo.vue?vue&type=template&id=7bc56658&"
import script from "./Invendo.vue?vue&type=script&lang=js&"
export * from "./Invendo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports